import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import Vuelidate from 'vuelidate';
import VuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor';
import { store } from './store';
// import amplitude from './plugins/amplitude';
import VueChatScroll from 'vue-chat-scroll'


import "@/scss/main.scss";


Vue.config.productionTip = false

Vue.use(VueChatScroll)
Vue.use(VuelidateErrorExtractor, {
  i18n: false,
  messages: {
    required: "required!",
    email: "Email is not a valid Email address",
    min: "Your password has to be at least 5 characters long.",
    isAuthorized: "Sorry, your Bizcode is incorrect or does not exist.",
    isBeezcode: "Your Bizcode should be 8 digits long.",

  }
});

Vue.use(Vuelidate);

Vue.component("form-group", templates.singleErrorExtractor.bootstrap3);

// Vue.use(amplitude,{
//   apiKey: process.env.VUE_APP_AMPLITUDE_API_KEY || " "
// });

// Vue.use(Throttle);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')